// yadsRecurringScheduleReducer.js
import {
  POST_YADS_RECURRING_REQUEST,
  POST_YADS_RECURRING_SUCCESS,
  POST_YADS_RECURRING_FAILURE,
  POST_YADS_RECURRING_RESET,
} from '../../../Constants/actionTypes';

const initial = {
  loading: false,
  result: null,
  error: '',
};

const yadsRecurringScheduleReducer = (state = initial, action) => {
  switch (action.type) {
    case POST_YADS_RECURRING_REQUEST:
      return { ...state, loading: true, error: '' };
    case POST_YADS_RECURRING_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case POST_YADS_RECURRING_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case POST_YADS_RECURRING_RESET:
      return initial;
    default:
      return state;
  }
};

export default yadsRecurringScheduleReducer;
